import * as types from "../actions/actionTypes";

import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function invalidCodeReducer(state = initialState.invalidCode, action: CurrentMentorsActions): boolean {
    switch (action.type) {
        case types.ERROR_LOADING_GUIDESTREAM:
            return true;
        default:
            return state;
    }
}
